import { render, staticRenderFns } from "./ProductBlocks.vue?vue&type=template&id=7e659967&"
import script from "./ProductBlocks.vue?vue&type=script&lang=js&"
export * from "./ProductBlocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports